import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../../../common/hooks/useI18n'
import { Element } from '../../../../../common/html/element'
import { ErrorMessage } from '../../errorMessage'
import { Input } from '../../input'

export const SaveAs = ({ name, handleChangeName, error, disabled }) => {
  return (
    <Element>
      <Element className="fw600" style={{ color: '#3A414B' }}>
        <Translate value="screening.SAVE_CRITERIA_AS" />
      </Element>
      <Element className="mt1">
        <Input
          noControl
          value={name}
          onChange={(e) => handleChangeName(e.target.value)}
          disabled={disabled}
          placeholder={UseI18n('screening.ENTER_CRITERIA_NAME')}
          wrapperStyle={{ backgroundColor: '#FFFFFF' }}
          autoFocus
        />
        <ErrorMessage value={error} isI18n={false} />
      </Element>
    </Element>
  )
}
